{
    "c0Zfn8cAUt_kQXX_HJ1X9": {
        "tag": "spawngood",
        "key": "c0Zfn8cAUt_kQXX_HJ1X9",
        "position": {
            "x": 6,
            "y": 5,
            "z": 1
        }
    },
    "H0VwBf7YpovV4ZAgolZsp": {
        "tag": "spawngood",
        "key": "H0VwBf7YpovV4ZAgolZsp",
        "position": {
            "x": 6,
            "y": 4,
            "z": 1
        }
    },
    "gsJEnuCGg6USUHfNMgWm-": {
        "tag": "spawngood",
        "key": "gsJEnuCGg6USUHfNMgWm-",
        "position": {
            "x": 6,
            "y": 3,
            "z": 1
        }
    }
}
